/**
 * ProjectChatPage Component
 *
 * Full-screen chat view for a specific conversation.
 * Uses the shared ChatView component with kebab menu,
 * image upload, and mute support.
 */

import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useChat } from '../../../contexts/ChatContext';
import ChatView from '../../../components/chat/ChatView';
import './ProjectChat.css';

const ProjectChatPage = () => {
  const { conversationId } = useParams();
  const navigate = useNavigate();
  const { loadConversations } = useChat();

  const handleBack = () => {
    navigate('/tecnico/mensajes');
  };

  const handleConversationDeleted = () => {
    loadConversations();
    navigate('/tecnico/mensajes');
  };

  return (
    <div className="chat-page-container">
      <ChatView
        conversationId={conversationId}
        onBack={handleBack}
        onConversationDeleted={handleConversationDeleted}
      />
    </div>
  );
};

export default ProjectChatPage;
